var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "trellis-assets": "static-1.2313"
    },
    "depPathPrefixes": {
      "trellis-assets": "/trellis-assets/static-1.2313"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.34112",
    "project": "trellis-assets",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};